import styled from 'styled-components';
import { RGBA_COLORS } from '../../utils/colors';

const MOD_PADDING = '24px';
export const ModalOuterWrapperS = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1002;
`;

export const ModalInnerWrapperS = styled.div`
  border-radius: 0;
  background-color: #ffffff;
  position: relative;
  border: 1px solid rgb(235, 235, 235);
  height: auto;
  max-height: 95vh;
  overflow: auto;
  width: 100%;
  max-width: 416px;
  display: flex;
  flex-direction: column;
`;

export const ModalHeaderS = styled.header`
  padding: 26px ${MOD_PADDING};

  input {
    border: 0;
    border-bottom: 1px solid #d8d8d8;
    background: transparent;
    padding: 0;
    font-size: 24px;
    font-weight: bold;
    border-radius: 0;
    &::placeholder {
      opacity: 0.8;
    }

    &:hover,
    &:focus {
      border-bottom: 1px solid ${RGBA_COLORS.getAccent()};
    }
  }
`;
export const ModalTileS = styled.h2`
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #171717;
  margin: 0;
`;
export const ModalSubtitleTileS = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  margin-bottom: 10px;
`;
export const ModalFooterS = styled.footer`
  padding: 16px ${MOD_PADDING};
  background: rgba(217, 225, 217, 0.24);
`;
export const ModalBodyS = styled.div`
  text-align: justify;
  padding: 0 ${MOD_PADDING} 32px;
  overflow: auto;
  flex: 1;
  /* max-height: 56vh; */
  hr {
    opacity: 0.12;
  }

  .btn-add {
    margin-top: 20px;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: #3c3c3c;
  }
`;
export const BtnsWrapperS = styled.footer`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  button {
    width: auto;
    margin-left: 16px;

    &:first-child {
      margin-left: 0;
    }
  }
`;
export const ErrorInfoS = styled.div`
  padding: 10px ${MOD_PADDING} 0;
`;
export const RowWrapperS = styled.div`
  display: flex;
  justify-content: space-between;
  & > * {
    width: 48% !important;
  }
`;

export const DescTitleS = styled.p`
  margin: 0;
  color: ${RGBA_COLORS.getDefault(0.5)};
  font-size: 1.4rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
`;
export const ModalBodyTextS = styled.p`
  font-size: 1.6rem;
`;

export const WrapBtn = styled.div`
  display: flex;
  justify-content: center;
  & > * {
    &:nth-child(1) {
      margin-right: 50px;
    }
  }
`;

export const WrapText = styled.h4`
  img {
    width: 50px;
    height: auto;
  }
`;
